import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32da03f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container page-container" }
const _hoisted_2 = { class: "alert alert-success" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-icons" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon-svg",
    focusable: "false",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#check-circle-outline" })
  ])
], -1))
const _hoisted_4 = { class: "alert-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "alert alert-warning" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-icons" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon-svg",
    focusable: "false",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#warning" })
  ])
], -1))
const _hoisted_8 = { class: "alert-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { id: "KvitteringInformation" }
const _hoisted_11 = {
  id: "kvittering-field",
  class: "kvittering-info"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_19 = {
  id: "kvittering-info",
  class: "kvittering-info"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = { key: 6 }
const _hoisted_30 = { key: 7 }
const _hoisted_31 = { id: "kvittering-download" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#download" })
], -1))
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#download" })
], -1))
const _hoisted_37 = { class: "kvittering-container" }
const _hoisted_38 = { class: "kvittering-container" }
const _hoisted_39 = { class: "brKvittering" }
const _hoisted_40 = { class: "kvittering-container" }
const _hoisted_41 = {
  id: "nyTCOButton",
  class: "kvittering-container"
}
const _hoisted_42 = {
  id: "ogBlanketbtnKvittering",
  type: "button",
  class: "button button-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_RichTekst = _resolveComponent("RichTekst")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("b", null, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.alerts.godkendttitel' }, null, 8, ["tekstNoegle"])
        ]),
        _hoisted_5,
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.alerts.godkendtbeskrivelse' }, null, 8, ["tekstNoegle"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("b", null, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.alerts.vigtigtitel' }, null, 8, ["tekstNoegle"])
        ]),
        _hoisted_9,
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.alerts.vigtigbeskrivelse' }, null, 8, ["tekstNoegle"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("h1", null, [
        _createVNode(_component_KlarTekst, {
          id: "hovedTitel",
          tekstNoegle: 'tco.kvittering.hovedtitel'
        }, null, 8, ["tekstNoegle"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", null, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.referencenummer' }, null, 8, ["tekstNoegle"]),
          _hoisted_12,
          _hoisted_13,
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.dato' }, null, 8, ["tekstNoegle"]),
          _hoisted_14,
          _hoisted_15,
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.udbudsnavn' }, null, 8, ["tekstNoegle"]),
          _hoisted_16,
          _hoisted_17,
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.udbudsnummer' }, null, 8, ["tekstNoegle"]),
          _hoisted_18
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        (this.referenceID != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(this.referenceID), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_21, "-")),
        _hoisted_22,
        (this.referenceID != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(this.currentDate), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_24, "-")),
        _hoisted_25,
        (this.udbudsNavn != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(this.udbudsNavn), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_27, "-")),
        _hoisted_28,
        (this.udbudsNummer != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(this.udbudsNummer), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("span", null, [
        _createElementVNode("p", null, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.downloadinformation' }, null, 8, ["tekstNoegle"]),
          _hoisted_32
        ])
      ]),
      _createElementVNode("button", {
        id: "kvitteringKnap",
        type: "button",
        onclick: "window.print();",
        class: "button button-primary button",
        disabled: this.referenceID == null || this.referenceID.isEmpty
      }, [
        _hoisted_34,
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.knap.downloadkvittering' }, null, 8, ["tekstNoegle"])
      ], 8, _hoisted_33),
      _createElementVNode("button", {
        id: "opsummeringKnap",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printExternal(this.url))),
        class: "button button-secondary button",
        disabled: this.referenceID == null || this.referenceID.isEmpty
      }, [
        _hoisted_36,
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.knap.downloadopsummering' }, null, 8, ["tekstNoegle"])
      ], 8, _hoisted_35)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("h2", null, [
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.undertitel' }, null, 8, ["tekstNoegle"])
      ]),
      _createVNode(_component_RichTekst, { tekstNoegle: 'tco.kvittering.undertitelbeskrivelse' }, null, 8, ["tekstNoegle"])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("h2", null, [
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.indkøb' }, null, 8, ["tekstNoegle"])
      ]),
      _createElementVNode("span", _hoisted_39, [
        _createVNode(_component_RichTekst, { tekstNoegle: 'tco.kvittering.indkøbsbeskrivelse' }, null, 8, ["tekstNoegle"]),
        _createVNode(_component_router_link, {
          to: "/overblikOG",
          class: "function-link",
          style: {"color":"blue"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.aktiveindkøb' }, null, 8, ["tekstNoegle"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("h2", null, [
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.spørgsmål' }, null, 8, ["tekstNoegle"])
      ]),
      _createElementVNode("span", null, [
        _createVNode(_component_RichTekst, { tekstNoegle: 'tco.kvittering.kontaktinformation' }, null, 8, ["tekstNoegle"])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_router_link, {
        to: "/blanket",
        class: "nav-link",
        "active-class": "current",
        style: {"text-decoration":"none","color":"inherit"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_42, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvittering.knap.opretindkøb' }, null, 8, ["tekstNoegle"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}